import { DateTime } from "luxon";

import { isSameDate } from ".";

export const isSaturday = (dt: DateTime) => {
  return dt.weekday === 6;
};

export const isSunday = (dt: DateTime) => {
  return dt.weekday === 7;
};

export const isWeekend = (dt: DateTime) => {
  return isSaturday(dt) || isSunday(dt);
};

export const isWeekday = (dt: DateTime) => {
  return !isWeekend(dt);
};

export const isToday = (date: DateTime, currentDate: DateTime = DateTime.now()) =>
  isSameDate(date, currentDate);

export const clearTime = (dt: DateTime) => {
  return dt.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
};

export const mergeDateTime = (date: DateTime, time: DateTime) => {
  return DateTime.local(date.year, date.month, date.day, time.hour, time.minute);
};

export const roundUpToNearestNMinutes = (minutes: number) => (dt: DateTime) => {
  const ms = 1000 * 60 * minutes;
  return DateTime.fromMillis(Math.ceil(dt.toMillis() / ms) * ms);
};

export const roundUpToNearest15 = roundUpToNearestNMinutes(15);

export const isDateWithin = (start: DateTime, end: DateTime, test: DateTime) => {
  return test >= start && test <= end;
};
